const TokenParser = require("./TokenParser");
const ASTBuilder = require("./ASTBuilder");

class TextScript {
    registry;
    tokenParser;
    ASTBuilder;
    emitter;

    constructor(registry) {
        this.registry = registry;

        this.tokenParser = new TokenParser(this.registry);
        this.ASTBuilder = new ASTBuilder(this.tokenParser);
        this.emitter = null;
    }

    async run(text, options) {
        try {
            const tokens = this.tokenParser.parse(text);
            const ast = this.ASTBuilder.build(tokens);
            return await this.emitter.emit(ast, options);
        } catch (error) {
            console.error("Error running text-script. Error: " + error);
        }
    }

    parse(text) {
        try {
            const tokens = this.tokenParser.parse(text);
            const ast = this.ASTBuilder.build(tokens);
            return {tokens: tokens, ast: ast};
        } catch (error) {
            console.error("Error parsing text-script. Error: " + error);
        }
    }

    parseObjectLiteralWithVariables(objStr) {
        const processedStr = objStr
            .replace(/:\s*\$\((.*?)\)(\s*)(,|\}|$)/g, ': "__EXPR__$1__"$3')
            .replace(/'/g, '"');

        const parsed = JSON.parse(processedStr);

        let objectHasVariable = false;
        Object.keys(parsed).forEach(key => {
            if (typeof parsed[key] === 'string' && parsed[key].startsWith('__EXPR__')) {
                objectHasVariable = true;

                const expr = parsed[key].match(/__EXPR__(.*)__/)[1];
                parsed[key] = {
                    isVariable: true,
                    value: expr
                };
            }
        });
        if (objectHasVariable) {
            console.warn('Problem parsing the script having object literal: ' + objStr);
        }

        return parsed;
    }

    getVariableFromAction(action) {
        if (action.type === "TextInput" && action.inputVariable) {
            return action.inputVariable;
        }

        if (action.type === 'TrackTime' && action.variableName) {
            return action.variableName;
        }

        if (action.type === 'GetTimeDuration' && action.variableName) {
            return action.variableName;
        }
        return null;
    }

    extractASTDetails(astNode) {
        const results = {
            stringLiterals: [],
            actionObjects: [],
            getPositionValues: [],
            variableLiterals: []
        };

        const self = this;

        function traverse(node) {
            if (node.type === 'expression') {
                const commandsWithFirstParamAsVariable = ['set', 'push', 'sadd'];
                if (commandsWithFirstParamAsVariable.includes(node.name.toLowerCase())) {
                    const stringLiteral = node.params.find(p => p.type === 'StringLiteral');
                    if (stringLiteral) {
                        results.stringLiterals.push(stringLiteral.value);
                    }

                    const variableLiteral = node.params.find(p => p.type === 'VariableLiteral');
                    if (variableLiteral) {
                        results.variableLiterals.push(variableLiteral.value);
                    }
                } else if (node.name === 'action') {
                    const objectLiteral = node.params.find(p => p.type === 'ObjectLiteral');
                    if (objectLiteral) {
                        try {
                            const jsonObject = self.parseObjectLiteralWithVariables(objectLiteral.value);
                            results.actionObjects.push(jsonObject);

                            const variable = self.getVariableFromAction(jsonObject);
                            if (variable) {
                                results.variableLiterals.push(variable);
                            }

                        } catch (error) {
                            throw new Error("Invalid object literal format: " + objectLiteral.value);
                        }
                    }
                } else if (node.name === 'query' && node.params[0]?.value === 'getPosition') {
                    const secondParam = node.params[1]?.value;
                    if (secondParam === 'volume') {
                        const lastStringLiteral = node.params[node.params.length - 1];
                        if (lastStringLiteral?.type === 'StringLiteral') {
                            results.getPositionValues.push(lastStringLiteral.value);
                        }
                    }
                }
            }

            if (node.params) {
                node.params.forEach(traverse);
            }
        }

        traverse(astNode);
        return results;
    }

}

module.exports = {
    TextScript
};